import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=a71c180e"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=a71c180e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports